import $ from 'jquery';

export default class OrderMainInfos {
  constructor($scope, $filter, UserService, GeoService, OrderService, OfferService, OrderSidebarService) {
    $scope.set_buyer_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.order.buyer_id = ui.item.id;
          $scope.order.buyer_user_contact_id = null;
          $scope.buyer_company = ui.item.value;
          $scope.$apply();
          $scope.update_buyer_data(ui.item.id);
        }
      });
    };

    $scope.update_buyer_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.buyer_contacts = data.contacts;
      });
    };

    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.order.supplier_id = ui.item.id;
          $scope.order.supplier_user_contact_id = null;
          $scope.supplier_company = ui.item.value;
          $scope.$apply();
          $scope.update_supplier_data(ui.item.id);
        }
      });
    };

    $scope.update_supplier_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.supplier_contacts = data.contacts;
      });
      OfferService.get_offer_ids(user_id).then(function(data) {
        $scope.offer_ids = data.offer_ids;
      });
    };

    $scope.update_order = function() {
      $scope.updating_order = true;
      if (!$scope.order.supplier_id) {
        $scope.form_error = 'Please select a supplier!';
        $scope.updating_order = false;
      } else if (!$scope.order.buyer_id) {
        $scope.form_error = 'Please select a buyer!';
        $scope.updating_order = false;
      } else if (!($scope.order.pi_id || $scope.order.oc_id || $scope.order.commercial_invoice)) {
        $scope.form_error = 'Please select PI or OC or Invoice ID!';
        $scope.updating_order = false;
      } else {
        $scope.form_error = '';
        OrderService.save($scope.order).then(function(data) {
          if (!data.success)
            $scope.form_error = data.message;
          $scope.updating_order = false;
          OrderSidebarService.set_main_infos_data(data.main_infos_percentage);
        });
      }
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.order = window.order;
      $scope.supplier_company = window.supplier_company;
      $scope.buyer_company = window.buyer_company;
      $scope.update_supplier_data(window.order.supplier_id);
      $scope.update_buyer_data(window.order.buyer_id);
      $scope.set_buyer_autocomplete($('input.buyer_company'));
      $scope.set_supplier_autocomplete($('input.supplier_company'));
      $scope.order_statuses = window.order_statuses;
    };

    $scope.init();
  }
}

OrderMainInfos.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'OrderService', 'OfferService', 'OrderSidebarService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-main-infos.ctrl.js